export default "__VITE_ASSET__8U04GnNw__"